 <template>
  <div>
    <headline>FAQ</headline>

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
          <i class="fa fa-calendar"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a href="/faq/calendar" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Outlook-Kalender</p>
            <p class="text-sm text-gray-500 truncate">
              Einrichten des persönlichen Outlook-Kalenders
            </p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
          <i class="fa fa-calendar"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a href="/faq/addin" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Outlook-Addin</p>
            <p class="text-sm text-gray-500 truncate">
              Einbinden unseres Outlook Addins
            </p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
          <i class="fa fa-server"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a href="/faq/saml" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">SAML SSO</p>
            <p class="text-sm text-gray-500 truncate">
              Einrichtung des ADFS mit SAML SSO
            </p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div>
          <i class="fa fa-question-circle align-top"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a href="mailto:support@parkefficient.de" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Fragen</p>
            <p class="text-sm text-gray-500 truncate">
              Bei Fragen wenden Sie sich bitte an:
              <a
                class="text-gray-800 font-semibold"
                href="mailto:support@parkefficient.de"
                >Support@parkefficient.de</a
              >
              <br />
              Damit wir Ihre Fragen bestmöglich beantworten können, <br />
              schicken Sie uns idealerweise Screenshots mit der Information,
              <br />
              auf welchem Endgerät Ihr Problem aufgetaucht ist.
            </p>
          </a>
        </div>
      </div>
    </div>


    <h2 class="mt-6 text-gray-900 font-bold">Anleitungen</h2>
    <div class="mt-2 grid grid-cols-1 gap-4 sm:grid-cols-2">


      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/1_OfficeEfficient__Einrichten__Anmelden_Login__SGkKOO-FSSGPHGIWk2MU6g" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900"> Anmelden/ Login</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/2_OfficeEfficient__Einrichten_Etage_hinzufugen__TGtmEGuESg643LJFi4_XVw" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Etage hinzufügen</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/3_OfficeEfficient__Einrichten_Lageplan_hochladen__GCp27CqNRfixIwqSitWGuw" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Lageplan hochladen</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/4_OfficeEfficient__Einrichten_Raume_anlegen___zMu_I4vRA6AGREKHc9yAA" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Räume anlegen</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/5_OfficeEfficient__Einrichten_Schreibtische_anlegen__FgjPB3zTTKCLyHznnMQQ0g" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Schreibtische anlegen</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/6_OfficeEfficient__Einrichten_Zuordnung_von_Raumen_zu_Etagen__vS4xq6MYQtmZ11TxAVy7Ug" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Zuordnung von Räumen zu Etagen</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/7_OfficeEfficient__Einrichten_Schreibtische_klickbar_machen__aK7Vkql1TIiZ53ENRBIdbA" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Schreibtische klickbar machen</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/8_OfficeEfficient__Einrichten_Zonen_anlegen__hy99IstAQQmPavceqfDCGQ" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Zonen anlegen</p>
          </a>
        </div>
      </div>

      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/9_OfficeEfficient__Einrichten_Nutzer_anlegen__vaAxz6qSSEaN4-hYU9wTog" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Nutzer anlegen</p>
          </a>
        </div>
      </div>



      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/10_OfficeEfficient__Einrichten_Nutzer_einladen_mit_Hilfe_einer_Excelliste_schnelle_Masseneinladung__jTRDQCXZRpeWLT5K7X1q9Q" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Nutzer einladen mit Hilfe einer Excelliste (schnelle Masseneinladung)</p>
          </a>
        </div>
      </div>


      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/11_OfficeEfficient__Einrichten_Nutzergruppen_anlegen__L4iEPAI_TficxwRp3JqZng" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Nutzergruppen anlegen</p>
          </a>
        </div>
      </div>


      <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/12_OfficeEfficient__Einrichten_Buchungsregeln__NnE6JFfURW6JNrVKcs8niQ" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Buchungsregeln</p>
          </a>
        </div>
    </div>

    <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/OfficeEfficient__Wie_geht_das__Schreibtisch_sperren__2D3kysI2RWWhJNiBOZfe5w" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Schreibtisch sprerren</p>
          </a>
        </div>
    </div>


    <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/OfficeEfficient__Wie_geht_das_Schreibtisch_Nutzern_fest_zuweisen__5pedVGDbSBO8zAfESg-zxQ" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Schreibtisch Nutzern fest zuweisen</p>
          </a>
        </div>
    </div>

    <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/OfficeEfficient__Wie_geht_das_Wie_buchen_Sie_als_Administrator_fur_Gaste_oder_dritte_Personen_einen_Schreibtisch__UqHOcxDARaSP1zuaYAhtXA" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Wie buchen Sie als Administrator für Gäste oder dritte Personen einen Schreibtisch</p>
          </a>
        </div>
    </div>


    <div
        class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-secondary"
      >
        <div class="flex-shrink-0 fa-duotone fa-calendar-day">
            <i class="fa fa-book" aria-hidden="true"></i>
        </div>
        <div class="flex-1 min-w-0">
          <a target="_blank" href="https://scribehow.com/shared/OfficeEfficient__Wie_geht_das_Einen_Nutzer_zum_Volladministrator_oder_Teiladministrator_ernennen_oder_das_Recht_entziehen__4YcQWuFfTYCgdZSa6Ab6-Q" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">Einen Nutzer zum Volladministrator oder Teiladministrator ernennen oder das Recht entziehen</p>
          </a>
        </div>
    </div>


      </div>

      

  </div>
</template> 

<script>
import Headline from "../components/UI/Headline";

export default {
  name: "Faq",
  components: { Headline },
};
</script>

<style scoped>